import type { AppButtonProps } from "./AppButton.Props";

export const isAppButtonProps = (props: {
  type: string;
}): props is AppButtonProps => {
  return (props as AppButtonProps).type === "AppButtonProps";
};
